import React, { useState } from "react";
import { Button, Tag, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const { Title } = Typography;

const nightOptions = [
  "2 - 5 Nights",
  "6 - 8 Nights",
  "9 - 11 Nights",
  "12+ Nights",
];

const NumberOfNightsFilter = ({ value = [], onChange }) => {
  const [selected, setSelected] = useState(value);

  const handleToggle = (option) => {
    const newSelection = selected.includes(option)
      ? selected.filter((item) => item !== option)
      : [option]; // single select
    setSelected(newSelection);
    onChange?.(newSelection);
  };

 

  return (
    <div className="bg-white rounded-xl flex flex-col justify-between min-h-[60vh]">
      {/* Content */}
      <div className="p-6 flex flex-col items-center">
        <Title
          level={4}
          className="text-[#1a1a1a] font-semibold text-center mb-8"
        >
          Number of nights
        </Title>

        <div className="w-full max-w-md">
          <h3 className="text-base font-semibold text-gray-700 mb-4 text-center">
            Length of cruise
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            {nightOptions.map((option) => {
              const isSelected = selected.includes(option);
              return (
                <button
                  key={option}
                  onClick={() => handleToggle(option)}
                  className={`rounded-full px-6 py-2 text-sm font-medium border transition-all
                    ${
                      isSelected
                        ? "bg-[#1a3aff] text-white border-[#1a3aff]"
                        : "text-[#1a3aff] border-[#1a3aff] hover:bg-[#e6ecff]"
                    }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      </div>

    </div>
  );
};

export default NumberOfNightsFilter;
